module.exports = __webpack_public_path__ + "img/chalkboard-user.4fe75400.svg";